module.exports = __webpack_public_path__ + "images/triumph9fbaccf86ea11460388cf15d8f793627.png";